__turbopack_context__.v({
  "Container": "ScopeSelection-module-scss-module__hwshQW__Container",
  "ErrorMessage": "ScopeSelection-module-scss-module__hwshQW__ErrorMessage",
  "Footer": "ScopeSelection-module-scss-module__hwshQW__Footer",
  "ScopeList": "ScopeSelection-module-scss-module__hwshQW__ScopeList",
  "Subtitle": "ScopeSelection-module-scss-module__hwshQW__Subtitle",
  "Title": "ScopeSelection-module-scss-module__hwshQW__Title",
});
